/// <reference path="../typings/globals/underscore/index.d.ts" />
/// <reference path="../node_modules/moment/moment.d.ts" />

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { HostModule } from './app/host.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(HostModule, { preserveWhitespaces: false})
  .catch(err => console.log(err));



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/main.ts